import {makeKey,update} from '../../../../utils/reducerOperations';
export function parseCsvStarted(state, payload) {
    return makeKey(
        'parseCsvApi',
        update(state.parseCsvApi, {isProcessing: true})
    );
}